export default __webpack_public_path__ + "static/media/flag_mx.820cd69c.png";